export default __webpack_public_path__ + "static/media/section3_1.1abd1136.png";